function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.98736 13.305L11.9996 22L21.0134 13.305C21.637 12.725 22.1371 12.0079 22.4799 11.2024C22.8226 10.3969 23 9.52173 23 8.63626C23 7.75078 22.8226 6.87564 22.4799 6.07012C22.1371 5.26461 21.637 4.54753 21.0134 3.96746L20.9028 3.86117C19.6816 2.70662 18.1212 2.04884 16.494 2.00261C14.8668 1.95639 13.2762 2.52466 11.9997 3.60825C10.6922 2.53579 9.07762 1.98506 7.43297 2.05061C5.78832 2.11615 4.21624 2.79388 2.98659 3.96745C2.36293 4.5475 1.86278 5.2646 1.52003 6.07016C1.17728 6.87572 0.999927 7.75091 1 8.63643C1.00007 9.52194 1.17757 10.3971 1.52045 11.2026C1.86334 12.0081 2.36361 12.7251 2.98736 13.305Z",
  fill: "#EB4962"
});

var SvgHeartFull = function SvgHeartFull(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeartFull, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/HeartFull.e07c0bed.svg";
export { ForwardRef as ReactComponent };